var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_vm._v(" loading ")])}
var staticRenderFns = []

export { render, staticRenderFns }